export default function pick(obj, ...keys) {
  return keys.reduce((acc, key) => {
    if (!(key in obj)) return acc;
    return Object.assign(acc, { [key]: obj[key] })
  }, {});
}
